var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7974 10.1763L13.824 6.20289M2.40039 21.5999L5.76227 21.2264C6.17301 21.1807 6.37838 21.1579 6.57034 21.0958C6.74064 21.0406 6.90272 20.9627 7.05216 20.8642C7.2206 20.7531 7.36671 20.607 7.65894 20.3148L20.7775 7.19625C21.8747 6.09902 21.8747 4.32006 20.7775 3.22283C19.6802 2.1256 17.9013 2.12559 16.8041 3.22282L3.68552 16.3414C3.39329 16.6336 3.24718 16.7797 3.13611 16.9481C3.03756 17.0976 2.95966 17.2596 2.90453 17.43C2.84239 17.6219 2.81957 17.8273 2.77393 18.238L2.40039 21.5999Z",
    stroke: "#AB5B0B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.7b76db17cfe1e4a158ce9c3ffba379a2.svg";
export { ForwardRef as ReactComponent };